/**
 * Show a list of subscriptions.  Used in the Subscriptions tab of the Customer page, and on the MyApps page.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, TablePagination } from '@mui/material';
import ResellerSubscriptionsList from './ResellerSubscriptionsList';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import SearchField from '../ui/SearchField';
import AppBindStyles from '../../AppBindStyles';
import ResellerSubscriptionsFetch from './ResellerSubscriptionsFetch';
import { GetApp } from '@mui/icons-material';
import { getCurrencyString } from '../../utils/InputUtils';

const abEnvironment = new AbEnvironment();

const ResellerSubscriptionsQuery = graphql`
query ResellerSubscriptionsQuery($vendorAccountId: UUID, $resellerAccountId: UUID, $searchTerm: String, $first: Int, $offset: Int) {
  getvendorresellersubscriptioncharges2(vendoraccountid: $vendorAccountId, reselleraccountid: $resellerAccountId, searchterm: $searchTerm, first: $first, offset: $offset) {
    totalCount
    ...ResellerSubscriptionsList_sl
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  flex: {
    flex: 1,
  }
});

class ResellerSubscriptions extends Component {

  constructor(props) {
    super(props);

    this.state = {
      resellerAccountId: this.props.resellerAccountId,
      // appName:           '', 
      customerName:      '', 
      page:              0,
      rowsPerPage:       10
    };  
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  setParentTab = (tv) => {
    if (this.props.setTabVal) {
      this.props.setTabVal(tv);
    }
  }

  goToFunding = () => {
    if (this.props.setTabVal) {
      this.props.setTabVal(1);
    }  else if (this.props.pscount != null && this.props.pscount === 0) {
      // Go to the funding page
      this.props.history.push("/fundingsources");
    }
  }

  render() {
    const { isAuthenticated, isAuthenticatedVendor, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticated() || needAssent() || !isAuthenticatedVendor()) { 
      return ( <Redirect to='/home' /> );
    }

    let vendorAccountId = abEnvironment.getUserAttribute('a_id');

    /*
    let theAppSearch = '%';
    if (this.state.appName !== '') {
      theAppSearch = '%' + this.state.appName + '%';
    }
    */
    let theCustomerSearch = '%';
    if (this.state.customerName !== '') {
      theCustomerSearch = '%' + this.state.customerName + '%';
    }
    
    // Determine the offset
    let offset = 0;
    if (this.state.page > 0) {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;
 
    return (
      <div className={classes.root}>
        <Grid container spacing={0} direction="row" justifyContent={'space-between'}>
          <Grid item>
            <SearchField
              id="customerName"
              label="Search by customer name or email"
              value={this.state.customerName}
              onChange={this.handleChange('customerName')}
            />
          </Grid>
          <Grid item>
          <Button
              color="primary"
              variant="contained"
              onClick={() => 
                this.downloadCsv(this.state.customerName, this.state.resellerAccountId, vendorAccountId, 10000, 0)
              }
            >
              Download&nbsp;&nbsp;<GetApp/>
            </Button>
          </Grid>
        </Grid>

        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={ResellerSubscriptionsQuery}
          variables={{vendorAccountId: vendorAccountId,
                      resellerAccountId: this.state.resellerAccountId,
                      // appName: theAppSearch,
                      searchTerm: theCustomerSearch,
                      first: first,
                      offset: offset}}
          render={({error, props})=> {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {
              // Determine offset information
              let totalCount = props.getvendorresellersubscriptioncharges2.totalCount;

              return (
                <div>
                  <ResellerSubscriptionsList sl={props.getvendorresellersubscriptioncharges2} 
                                           history={this.props.history}
                                           resellerAccountId={this.state.resellerAccountId}/>
                  <div style={AppBindStyles.paginationTableFooter}>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={totalCount}
                      rowsPerPage={this.state.rowsPerPage}
                      page={this.state.page}
                      backIconButtonProps={{
                        'aria-label': 'Previous Page',
                      }}
                      nextIconButtonProps={{
                        'aria-label': 'Next Page',
                      }}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />                        
                  </div>
                </div>
              )
            }
            return (
              <LoadingSpinner />
            );
          }}
        />
      </div>
    );
  }

  downloadCsv(accountName, pAccountId, vendorAccountId, first, offset) {
    const { logError } = this.props.auth;

    //account name is input text, real search is surround that with like %
    let nameSearch;
    if (accountName == null || accountName === '') {
      nameSearch = '%';
    } else {
      nameSearch = '%' + accountName + '%';
    }

    ResellerSubscriptionsFetch.fetch(nameSearch, pAccountId, vendorAccountId, first, offset).toPromise()
    .then((slfetch) => {
      
      let csv;
      
      csv = 'Customer account name,Customer first name,Customer last name,Customer email,Customer address line 1,'
      +'Customer address line 2,Customer city,Customer state,Customer country,Customer postal code,'
      +'App name,Plan,Billed last 30 days,Commissions last 30 days\n';

      console.log(JSON.stringify(slfetch));
      let subCharges = slfetch.getvendorresellersubscriptioncharges2;
      subCharges.nodes.map((n, index) => {
        
        let tmBcSum = getCurrencyString(n.tmBcSum);
        let tmRebateSum = getCurrencyString(n.tmRebateSum);
        
        let appName = n.appName;
        /* eslint-disable eqeqeq */
        if (n.appSku != null && n.appSku !== '' && n.appSku != n.appName) {
          appName = n.appName + " (" + n.appSku + ")";
        }

        //address data may be empty or null, convert for csv proper filling
        let address1 = n.customerAddress1 == null || n.customerAddress1 === '' ? 'Not specified' : n.customerAddress1;
        let address2 = n.customerAddress2 == null || n.customerAddress2 === '' ? '' : n.customerAddress2;
        let customerCity = n.customerCity && n.customerState && n.customerCountry && n.customerPostalCode ? n.customerCity : '';
        let customerState = n.customerCity && n.customerState && n.customerCountry && n.customerPostalCode ? n.customerState : '';
        let customerCountry = n.customerCity && n.customerState && n.customerCountry && n.customerPostalCode ? n.customerCountry : '';
        let customerPostalCode = n.customerCity && n.customerState && n.customerCountry && n.customerPostalCode ? n.customerPostalCode : '';
        
        /*
        let subStatus = '';
        //status: 0 = active, 1 = paused, 2 = canceled.
        if (n.customerAppStatus == 1) {
          subStatus = 'Paused'
        } else if (n.customerAppStatus == 2) {
          subStatus = 'Canceled'
        } else if (n.customerAppStatus == 0) {
          subStatus = 'Active';
        }
        */
        
        //construct line: double quotes around individual fields to prevent commas from breaking format.
        let csvline = '"'  + n.customerAccountName + '","' + n.customerFirstName + '","' + n.customerLastName + '","' + n.customerContactEmail + '","'
        + address1 + '","' + address2 + '","' + customerCity + '","' + customerState + '","' + customerCountry + '","' + customerPostalCode + '","'
        + appName + '","' + n.programName + '","' + tmBcSum + '","' + tmRebateSum + '"\n';
        
        csv = csv + csvline;
        return true;
      });
      
      //construct csv document for downloading... could we do this without href manipulation?
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'profitability.csv';
      hiddenElement.click();

    }).catch(error => {
      logError("fetch of subs went wrong: ", error);
    });
  }

}
  
ResellerSubscriptions.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(ResellerSubscriptions);
